const validateEtaDuration = (openingHours, EtaMinutes) => {
  return openingHours.some(
    (el) => Math.round(el?.Duration) <= Math.round(EtaMinutes)
  );
};

export default validateEtaDuration;
